import { Outlet } from "react-router-dom"

const AdminOrdersScreen = () => {
  return (
    <>
      <Outlet />
    </>
  )
}

export default AdminOrdersScreen
